import { format } from "date-fns";
import csc from "country-state-city";

export const formatDateTime = (date) => {
  if (!date) return "--";

  try {
    return format(new Date(date), "dd MMM, yyyy hh:mm a");
  } catch (error) {
    return "--";
  }
};
export const GOOGLE_PLACES_API_KEY =
  process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
export const STRIPE_PB_KEY = process.env.REACT_APP_STRIPE_PB_KEY;
export const VERIFF_KEY = process.env.REACT_APP_VERIFF_KEY;

/** sessionStorage: KYC shipping snapshot to prefill the apply-card (card type) step */
export const APPLY_CARD_SHIPPING_PREFILL_KEY =
  "stbl_apply_card_shipping_prefill";

//socket
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const WEB_URL = process.env.REACT_APP_WEB_URL;
export const FORMIK_REGEX = {
  ALPHA: /^[A-Za-z\s]+$/,
  USERNAME: /^[a-zA-Z0-9._]*$/,
  SPACE: /^[a-zA-Z0-9._]*$/,
  EMAIL:
    /^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.(com|net|org|edu|gov|mil|in|co|info|biz|name|me|mail|io)$/i,
  NUMBER: /^\d+$/,
  ALPHASPACE: /^[a-zA-Z ]*$/,
  DECIMALNUMBERS: /^\d*(\.\d+)?$/,
  INPUT_DECIMAL: /^\d*\.?\d*$/, // 
  NONZERODECIMAL: /^\s*(?=.*[1-9])\d*(?:\.\d{1,5})?\s*$/,
  WHOLENUMBER: /^[1-9]\d*$/,
  TWODECIMALNUMBER: /^\d+(\.\d{0,2})?$/,
};

export const assetOptions = [
  {
    label: "Gold STBL",
    value: 1,
    symbol: "XAU/USD",
  },
  {
    label: "Silver STBL",
    value: 2,
    symbol: "XAG/USD",
  },
];

export const TYPE = {
  DISABLE: "DISABLE",
  ENABLE: "ENABLE",
  EMAIL: "EMAIL",
  MOBILE: "MOBILE",
  SMS: "SMS",
  DEVICE_TYPE: 0,
};

export const PAYMENTMETHODS = [
  {
    label: "STRIPE",
    value: 1,
  },
  {
    label: "WIRE",
    value: 2,
  },
];

export const Messages = {
  tokenInvalid: "Token is invalid!",
  apiAccessToken: "api-access-token",
  invalidEmail: "Email is invalid",
  emailRequired: "Email is required",
  passwordRequired: "Password is required",
  documentTypeRequired: "Document Type is required",
  oldPasswordRequired: "Old Password is required",
  passwordDoNotMatchOldPassword:
    "New Password Should not match with Old Password",
  confirmPasswordRequired: "Confirm password is required",
  frontImageIsRequired: "Front Image is required",
  backImageIsRequired: "Back Image is required",
  selfieImageIsRequired: "Selfie Image is required",
  userNameIsRequired: "User Name is required",
  addressIsRequired: "Address is required",
  pinCodeIsRequired: "Pin Code is required",
  cityIsRequired: "City is required",
  dobIsRequired: "DOB is required",
  nationalIdIsRequired: "National Id is required",
  pinMustBeThreeChar: "Pin must be at least 3 characters",
  ageLimit: "Date of Birth should be Greater than 18 Years",
  verificationCodeRequired: "verification code must be Required",
  passwordOfSixCharacters: "Password must be at least 8 characters",
  passwordMustMatch: "Password must match!",
  sixDigitsCode: "code must be of 6 digits",
  googleVerificationCodeRequired: "google verification code must be Required",
  passwordCharacters:
    "Password must contain one uppercase, one lowercase, one number, one special character and must be at least 8 characters long.",
  passwordTextChar:
    /^.*(?=.{6})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
  passwordMaxCharacters: "Password must not be greater than 40 characters",
  USERNAMEVALIDATION:
    "Must contain only letters, numbers, periods and underscores.",
  ALPHABETSVALIDATION: "Only Alphabets accepted",
  NUMBERVALIDATION: "Only Numbers accepted",
  NONZERODECIMALVALIDATION: "Invalid value",
};

export const isNumber = (evt) => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (
    evt?.nativeEvent?.shiftKey === true ||
    charCode === 189 ||
    charCode === 109 ||
    charCode === 69
  ) {
    return true;
  }
  if (
    charCode === 190 ||
    charCode === 110 ||
    charCode === 37 ||
    charCode === 39 ||
    (charCode === 86 && evt?.nativeEvent?.ctrlKey === true) ||
    (charCode === 67 && evt?.nativeEvent?.ctrlKey === true) ||
    (95 < charCode && charCode < 106)
  ) {
    return false;
  }
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return true;
  }
  return false;
};

export const SERVICESTYPE = {
  EMAIL: "EMAIL",
  OTP: "OTP",
};
export const SERVICES = {
  login: "login",
  register: "REGISTER",
  FORGOTPASSWORD: "FORGOTPASSWORD",
};

export const STATUS_CODE = {
  successful: 200,
  notModified: 304,
  badRequest: 400,
  unAuthorized: 401,
  forbidden: 403,
  notFound: 404,
};

/** STBL card is hidden for these jurisdictions (ISO2 codes and display names). */
export const RESTRICTED_COUNTRIES = [
  "BY",
  "Belarus",
  "CN",
  "China",
  "China (Mainland)",
  "CU",
  "Cuba",
  "IN",
  "India",
  "IR",
  "Iran",
  "IQ",
  "Iraq",
  "IL",
  "Israel",
  "MM",
  "Myanmar",
  "NP",
  "Nepal",
  "NI",
  "Nicaragua",
  "KP",
  "North Korea",
  "RU",
  "Russia",
  "SY",
  "Syria",
  "TR",
  "Turkey",
  "UA",
  "Ukraine",
  "VE",
  "Venezuela",
  "VN",
  "Vietnam",
];

export const isStblCardRestrictedCountry = (country) => {
  if (country == null || String(country).trim() === "") {
    return false;
  }
  const normalized = String(country).trim().toLowerCase();
  return RESTRICTED_COUNTRIES.some(
    (entry) => String(entry).trim().toLowerCase() === normalized
  );
};

/* ---- KYC card form: country list + phone codes (country-state-city) ---- */
const KYC_RESTRICTED_ISO_CODES = new Set();
const KYC_RESTRICTED_NAMES = new Set();

RESTRICTED_COUNTRIES.forEach((item) => {
  const s = String(item).trim();
  if (/^[A-Za-z]{2}$/.test(s)) {
    KYC_RESTRICTED_ISO_CODES.add(s.toUpperCase());
  } else {
    KYC_RESTRICTED_NAMES.add(s.toLowerCase());
  }
});

/** True if this country-state-city country row is in {@link RESTRICTED_COUNTRIES}. */
export const isKycFormRestrictedCountry = (country) => {
  const iso = (country.sortname || "").toUpperCase();
  if (KYC_RESTRICTED_ISO_CODES.has(iso)) return true;
  const n = (country.name || "").toLowerCase();
  if (KYC_RESTRICTED_NAMES.has(n)) return true;
  return false;
};

const ALL_COUNTRIES_KYC = csc.getAllCountries();

/** Countries allowed on KYC apply-card form (not restricted). */
export const ALLOWED_COUNTRIES = ALL_COUNTRIES_KYC.filter(
  (c) => !isKycFormRestrictedCountry(c),
);

/** ISO2 codes allowed for country of issue / address (uppercase). */
export const ALLOWED_ISO_CODES = ALLOWED_COUNTRIES.map((c) =>
  c.sortname.toUpperCase(),
);

/**
 * Phone calling code (digits only, no +) by ISO2 for allowed countries.
 * Source: country-state-city `phonecode`.
 */
export const PHONE_CODE_BY_COUNTRY_ISO = Object.fromEntries(
  ALLOWED_COUNTRIES.map((c) => [
    c.sortname.toUpperCase(),
    String(c.phonecode ?? "").replace(/\D/g, ""),
  ]),
);

/** Phone country code for an allowed ISO2 (e.g. `"US"` → `"1"`). */
export const getPhoneCodeByCountryIso = (iso) => {
  if (!iso) return "";
  return PHONE_CODE_BY_COUNTRY_ISO[String(iso).toUpperCase()] ?? "";
};

export const countryByIso = (iso) =>
  ALLOWED_COUNTRIES.find(
    (c) => c.sortname.toUpperCase() === String(iso || "").toUpperCase(),
  );


export const getKycCountryIsoFromUserProfileCountry = (countryField) => {
  if (countryField == null) return "US";
  const raw = String(countryField).trim();
  if (!raw) return "US";

  const isoCandidate = raw.toUpperCase();
  if (/^[A-Z]{2}$/.test(isoCandidate)) {
    return ALLOWED_ISO_CODES.includes(isoCandidate) ? isoCandidate : "US";
  }

  const normalizedName = raw.toLowerCase().replace(/\s+/g, " ");
  const byName = ALLOWED_COUNTRIES.find((c) => {
    const n = c.name.trim().toLowerCase().replace(/\s+/g, " ");
    return n === normalizedName;
  });
  if (byName) return byName.sortname.toUpperCase();

  return "US";
};

/** Options for Country of Issue select (react-select). */
export const COUNTRY_OF_ISSUE_OPTIONS = ALLOWED_COUNTRIES.map((country) => {
  const iso = country.sortname.toUpperCase();
  return {
    label: country.name,
    value: iso,
    phonecode: PHONE_CODE_BY_COUNTRY_ISO[iso] ?? "",
    id: country.id,
  };
});